import { localStorageUtil } from '../../utils/local-storage.util';

export const showOnboardingPageState = localStorageUtil<boolean>('showOnboardingPage');
